// extracted by mini-css-extract-plugin
export default {"defaultProjectListClass":"ProjectList_defaultProjectListClass__op9so","footerLinksOpen":"ProjectList_footerLinksOpen__gkFnp"};